import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { NGXLogger } from 'ngx-logger';

const MARKETO_COOKIE_NAME = "_mkto_trk";

@Injectable()
export class MarketoIntegrationService {

    constructor(
        private readonly cookieService: CookieService,
        private readonly logger: NGXLogger
    ) { }

    public getMarketoCookie(): string {
        const marketoCookieValue: string = this.cookieService.get(MARKETO_COOKIE_NAME);
        this.logger.debug("Marketo cookie value retrieved", marketoCookieValue);
        return marketoCookieValue;
    }

}
